module.exports = __webpack_public_path__ + "jersey.svg?ebf8c8c5daac45b568b1b7a467c39675";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/jersey.svg
// module id = 201
// module chunks = 10